import _classCallCheck from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import * as base64url from '../runtime/base64url.js';
import { decoder } from '../lib/buffer_utils.js';
import { JWTInvalid } from '../util/errors.js';
import jwtPayload from '../lib/jwt_claims_set.js';
import { ProduceJWT } from './produce.js';
export var UnsecuredJWT =
/*#__PURE__*/
function (_ProduceJWT) {
  _inherits(UnsecuredJWT, _ProduceJWT);

  function UnsecuredJWT() {
    _classCallCheck(this, UnsecuredJWT);

    return _possibleConstructorReturn(this, _getPrototypeOf(UnsecuredJWT).apply(this, arguments));
  }

  _createClass(UnsecuredJWT, [{
    key: "encode",
    value: function encode() {
      var header = base64url.encode(JSON.stringify({
        alg: 'none'
      }));
      var payload = base64url.encode(JSON.stringify(this._payload));
      return "".concat(header, ".").concat(payload, ".");
    }
  }], [{
    key: "decode",
    value: function decode(jwt, options) {
      if (typeof jwt !== 'string') {
        throw new JWTInvalid('Unsecured JWT must be a string');
      }

      var _jwt$split = jwt.split('.'),
          encodedHeader = _jwt$split[0],
          encodedPayload = _jwt$split[1],
          signature = _jwt$split[2],
          length = _jwt$split.length;

      if (length !== 3 || signature !== '') {
        throw new JWTInvalid('Invalid Unsecured JWT');
      }

      var header;

      try {
        header = JSON.parse(decoder.decode(base64url.decode(encodedHeader)));
        if (header.alg !== 'none') throw new Error();
      } catch (_a) {
        throw new JWTInvalid('Invalid Unsecured JWT');
      }

      var payload = jwtPayload(header, base64url.decode(encodedPayload), options);
      return {
        payload: payload,
        header: header
      };
    }
  }]);

  return UnsecuredJWT;
}(ProduceJWT);